import { meta } from '@/helpers/constants/router';
import { ECOMMERCE_PRODUCT_MENU_KEY, ECOMMERCE_ORDER_MENU_KEY, ECOMMERCE_CART_MENU_KEY, ECOMMERCE_MARKETING_MENU_KEY, CUSTOMER_SEGMENT, STORE_SETUP_MENU_KEY, } from '@/helpers/constants/app';
// lazy load components
// https://router.vuejs.org/guide/advanced/lazy-loading.html
const Products = () => import('@/views/v2/ecommerce/Products.vue');
const Categories = () => import('@/views/v2/ecommerce/Categories.vue');
const Wrapper = () => import('@/views/Wrapper.vue');
const Referrals = () => import('@/views/v2/Referrals.vue');
const ReferralList = () => import('@/components/v2/ReferralLinks.vue');
const SmartRetailLinks = () => import('@/components/v2/SmartRetailLinks.vue');
const productsTitle = 'Products';
const productsRouteName = 'insurance-products';
const cartSettingsRouteName = 'insurance-cart-settings';
const storeSetupRouteName = 'insurance-store-setup';
export default [
    {
        path: 'insurance',
        component: Wrapper,
        children: [
            {
                path: 'products',
                component: Wrapper,
                redirect: productsRouteName,
                meta: { ...meta, title: 'Products' },
                children: [
                    {
                        path: ':componentUUID',
                        component: Wrapper,
                        children: [
                            {
                                path: 'categories',
                                component: Wrapper,
                                meta,
                                children: [
                                    {
                                        path: '/',
                                        name: 'insurance-categories',
                                        component: Categories,
                                        meta: {
                                            title: 'Categories',
                                            subtitle: 'Customize your categories. Drag and drop to arrange category sequence',
                                            parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                                        },
                                    },
                                    {
                                        path: 'create',
                                        name: 'insurance-categories-create',
                                        component: () => import('@/views/v2/ecommerce/CategoryCreate.vue'),
                                        meta: {
                                            title: 'Create Category',
                                            parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                                        },
                                    },
                                    {
                                        path: ':uuid',
                                        meta: { title: 'Categories' },
                                        component: Wrapper,
                                        children: [
                                            {
                                                path: 'edit',
                                                name: 'insurance-categories-update',
                                                component: () => import('@/views/v2/ecommerce/CategoryUpdate.vue'),
                                                props: true,
                                                meta: {
                                                    title: 'Edit Category',
                                                    parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                                                },
                                            },
                                            {
                                                path: 'details',
                                                name: 'insurance-category-details',
                                                component: () => import('@/views/v2/ecommerce/CategoryDetails.vue'),
                                                props: true,
                                                meta: {
                                                    title: 'Category Details',
                                                    parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: '/',
                                name: productsRouteName,
                                component: Products,
                                meta: {
                                    title: productsTitle,
                                    parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                                    subtitle: 'Customize product information such as product description, price and variances.',
                                },
                            },
                            {
                                path: 'create',
                                name: 'insurance-products-create',
                                component: () => import('@/views/v2/ecommerce/ProductsCreate.vue'),
                                meta: {
                                    title: 'Create Product',
                                    parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                                },
                            },
                            {
                                path: ':uuid',
                                component: Wrapper,
                                children: [
                                    {
                                        path: '/',
                                        name: 'insurance-products-details',
                                        component: () => import('@/views/v2/ecommerce/ProductDetails.vue'),
                                        props: true,
                                        meta: {
                                            title: 'Product Details',
                                            parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                                        },
                                    },
                                    {
                                        path: 'edit',
                                        name: 'insurance-products-edit',
                                        component: () => import('@/views/v2/ecommerce/ProductsEdit.vue'),
                                        props: true,
                                        meta: {
                                            title: 'Edit Product',
                                            parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: 'overview',
                component: Wrapper,
                meta: { ...meta, title: 'Overview' },
                children: [
                    {
                        path: 'sales-funnel',
                        component: Wrapper,
                        meta: {
                            title: 'Overview',
                            redirect: 'insurance-overview',
                        },
                        children: [
                            {
                                path: '/',
                                name: 'insurance-sales-funnel',
                                component: () => import('@/views/v2/ecommerce/SalesFunnel.vue'),
                                meta: {
                                    title: 'Sales Funnel',
                                },
                            },
                        ],
                    },
                    {
                        path: '/',
                        component: Wrapper,
                        meta: {
                            title: 'Overview',
                            redirect: 'insurance-overview',
                        },
                        children: [
                            {
                                path: '/',
                                name: 'insurance-overview',
                                component: () => import('@/views/v2/ecommerce/Overview.vue'),
                                meta: {
                                    title: 'Overview',
                                },
                            },
                            {
                                path: 'latest-sold-products',
                                name: 'insurance-sold-products',
                                component: () => import('@/components/v2/ecommerce/LatestSoldProductsIndex.vue'),
                                meta: { title: `Today's Latest Sold Products` },
                            },
                            {
                                path: 'sales-amount',
                                name: 'insurance-sales-amount',
                                component: () => import('@/components/v2/ecommerce/SalesAmountIndex.vue'),
                                meta: { title: `Today's Sales Amount` },
                            },
                            {
                                path: 'latest-customers',
                                name: 'insurance-latest-customers',
                                component: () => import('@/components/v2/ecommerce/LatestCustomersIndex.vue'),
                                meta: { title: `Today's Latest Customers` },
                            },
                        ],
                    },
                    {
                        path: 'performance',
                        component: Wrapper,
                        meta: {
                            title: 'Mini App Performance',
                            redirect: 'insurance-performance',
                        },
                        children: [
                            {
                                path: '/',
                                name: 'insurance-performance',
                                component: () => import('@/views/v2/ecommerce/Performance.vue'),
                                meta: {
                                    title: 'Mini App Performance',
                                },
                            },
                            {
                                path: 'popular-producs',
                                name: 'insurance-popular-products',
                                component: () => import('@/views/v2/ecommerce/PopularProductList.vue'),
                                meta: {
                                    title: 'Most Viewed Products',
                                    parentMenu: 'insurance-performance',
                                },
                            },
                            {
                                path: 'most-sold-producs',
                                name: 'insurance-profitable-products',
                                component: () => import('@/views/v2/ecommerce/ProfitableProductList.vue'),
                                meta: {
                                    title: 'Most Sold Products',
                                    parentMenu: 'insurance-performance',
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'customers',
                component: Wrapper,
                meta: { ...meta, title: CUSTOMER_SEGMENT },
                children: [
                    {
                        path: '/',
                        name: 'insurance-customers',
                        meta: { title: CUSTOMER_SEGMENT, parentMenu: ECOMMERCE_MARKETING_MENU_KEY },
                        component: () => import('@/views/v2/Customers.vue'),
                    },
                ],
            },
            {
                path: 'store-setup',
                component: Wrapper,
                redirect: storeSetupRouteName,
                meta: { ...meta, title: 'Store Setup' },
                children: [
                    {
                        path: 'cart-settings',
                        name: cartSettingsRouteName,
                        component: () => import('@/views/v2/ecommerce/CartSetting.vue'),
                        meta: {
                            title: 'Checkout Settings',
                            parentMenu: STORE_SETUP_MENU_KEY,
                            subtitle: 'Manage your cart settings such as Delivery Fee, Free Shipping, ' +
                                'Minimum Purchase Amount, Address Input and Location Scope.',
                        },
                    },
                    {
                        path: 'delivery-areas',
                        component: Wrapper,
                        redirect: 'insurance-delivery-areas',
                        meta: { ...meta, title: 'Delivery Areas' },
                        children: [
                            {
                                path: '/',
                                name: 'insurance-delivery-areas',
                                component: () => import('@/views/v2/apps/DeliveryAreas.vue'),
                                meta: {
                                    title: 'Delivery Areas',
                                    subtitle: 'Manage your delivery locations',
                                    parentMenu: STORE_SETUP_MENU_KEY,
                                },
                            },
                            {
                                path: 'create',
                                name: 'insurance-delivery-areas-create',
                                component: () => import('@/views/v2/apps/DeliveryAreaCreate.vue'),
                                meta: {
                                    title: 'Create Delivery Area',
                                    parentMenu: STORE_SETUP_MENU_KEY,
                                },
                            },
                            {
                                path: ':uuid',
                                component: Wrapper,
                                meta,
                                children: [
                                    {
                                        path: 'edit',
                                        name: 'insurance-delivery-areas-edit',
                                        props: true,
                                        component: () => import('@/views/v2/apps/DeliveryAreaEdit.vue'),
                                        meta: {
                                            title: 'Edit Delivery Area',
                                            parentMenu: STORE_SETUP_MENU_KEY,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: 'shipping-methods',
                        component: Wrapper,
                        redirect: 'insurance-shipping',
                        meta: { ...meta, title: 'Shipping' },
                        children: [
                            {
                                path: '/',
                                name: 'insurance-shipping',
                                component: () => import('@/views/v2/apps/ShippingMethods.vue'),
                                meta: {
                                    title: 'Shipping',
                                    subtitle: 'Manage your shipping methods',
                                    parentMenu: STORE_SETUP_MENU_KEY,
                                },
                            },
                            {
                                path: 'create',
                                name: 'insurance-shipping-create',
                                component: () => import('@/views/v2/apps/ShippingMethodsCreate.vue'),
                                meta: { title: 'Create Shipping Method', parentMenu: STORE_SETUP_MENU_KEY },
                            },
                            {
                                path: ':uuid',
                                component: Wrapper,
                                meta,
                                children: [
                                    {
                                        path: 'edit',
                                        name: 'insurance-shipping-edit',
                                        props: true,
                                        component: () => import('@/views/v2/apps/ShippingMethodsEdit.vue'),
                                        meta: { title: 'Edit Shipping Method', parentMenu: STORE_SETUP_MENU_KEY },
                                    },
                                ],
                            },
                            {
                                path: ':uuid',
                                component: Wrapper,
                                meta,
                                children: [
                                    {
                                        path: 'top-up',
                                        name: 'insurance-shipping-top-up',
                                        props: true,
                                        component: () => import('@/views/v2/apps/ShippingMethodsTopUp.vue'),
                                        meta: { title: 'Grab Express Top-Up', parentMenu: STORE_SETUP_MENU_KEY },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: 'payment',
                        redirect: 'insurance-payment',
                        component: Wrapper,
                        meta: { ...meta, title: 'Payment' },
                        children: [
                            {
                                path: '/',
                                name: 'insurance-payment',
                                component: () => import('@/views/v2/Payments.vue'),
                                meta: {
                                    title: 'Payment',
                                    subtitle: 'Manage your payment options',
                                    parentMenu: STORE_SETUP_MENU_KEY,
                                },
                            },
                            {
                                path: 'merchant',
                                name: 'insurance-merchant-registration',
                                component: () => import('@/views/v2/MerchantPaymentRegistration.vue'),
                                meta: {
                                    title: 'Merchant Registration',
                                    parentMenu: STORE_SETUP_MENU_KEY,
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'promos',
                component: Wrapper,
                redirect: 'insurance-promos',
                meta: { ...meta, title: 'Voucher' },
                children: [
                    {
                        path: '/',
                        name: 'insurance-promos',
                        component: () => import('@/views/v2/apps/PromoCodes.vue'),
                        meta: {
                            title: 'Discounts',
                            parentMenu: ECOMMERCE_CART_MENU_KEY,
                        },
                    },
                    {
                        path: 'create',
                        name: 'insurance-promos-create',
                        component: () => import('@/views/v2/apps/PromoCodeCreate.vue'),
                        meta: { title: 'Create Promo Code', parentMenu: ECOMMERCE_CART_MENU_KEY },
                    },
                    {
                        path: ':uuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'edit',
                                name: 'insurance-promos-edit',
                                props: true,
                                component: () => import('@/views/v2/apps/PromoCodeEdit.vue'),
                                meta: { title: 'Edit Promo Code', parentMenu: ECOMMERCE_CART_MENU_KEY },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'cart-promos',
                component: Wrapper,
                redirect: 'insurance-cart-promos',
                meta: { title: 'Cart Promos' },
                children: [
                    {
                        path: '/',
                        name: 'insurance-cart-promos',
                        component: () => import('@/views/v2/apps/CartPromos.vue'),
                        meta: {
                            title: 'Cart Promos',
                            parentMenu: STORE_SETUP_MENU_KEY,
                            subtitle: 'Set free shipping, set minimum purchase amount, and freebies',
                        },
                    },
                    {
                        path: 'create',
                        name: 'insurance-cart-promos-create',
                        component: () => import('@/views/v2/apps/CartPromoCreate.vue'),
                        meta: {
                            title: 'Create Cart Promo',
                            parentMenu: STORE_SETUP_MENU_KEY,
                        },
                    },
                    {
                        path: ':uuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'edit',
                                name: 'insurance-cart-promos-edit',
                                props: true,
                                component: () => import('@/views/v2/apps/CartPromoEdit.vue'),
                                meta: {
                                    title: 'Edit Cart Promo',
                                    parentMenu: STORE_SETUP_MENU_KEY,
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'add-ons',
                component: Wrapper,
                redirect: 'insurance-add-ons',
                meta: { ...meta, title: 'Add - Ons / Upsell' },
                children: [
                    {
                        path: '/',
                        name: 'insurance-add-ons',
                        meta: {
                            title: 'Add - Ons / Upsell',
                            subtitle: 'Upsell your other services like gift wrapping, additional box and etc.',
                            parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                        },
                        component: () => import('@/views/v2/apps/CartAddOns.vue'),
                    },
                    {
                        path: 'create',
                        name: 'insurance-add-ons-create',
                        component: () => import('@/views/v2/apps/CartAddOnsCreate.vue'),
                        meta: { title: 'Create Add-Ons', parentMenu: ECOMMERCE_PRODUCT_MENU_KEY },
                    },
                    {
                        path: ':uuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'edit',
                                name: 'insurance-add-ons-edit',
                                props: true,
                                component: () => import('@/views/v2/apps/CartAddOnsEdit.vue'),
                                meta: { title: 'Edit Add-Ons', parentMenu: ECOMMERCE_PRODUCT_MENU_KEY },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'orders',
                component: Wrapper,
                redirect: 'insurance-orders-by-status',
                meta: { ...meta, title: 'Orders' },
                children: [
                    {
                        path: 'history',
                        name: 'insurance-order-history',
                        meta: {
                            title: 'Order History',
                            subtitle: 'View and track all your orders here.',
                            parentMenu: ECOMMERCE_ORDER_MENU_KEY,
                        },
                        props: true,
                        component: () => import('@/views/v2/ecommerce/OrderHistory.vue'),
                    },
                    {
                        path: ':status/:filter?',
                        component: () => import('@/views/v2/ecommerce/Orders.vue'),
                        children: [
                            {
                                path: '/',
                                name: 'insurance-orders-by-status',
                                meta: {
                                    title: 'Order Tracker',
                                    subtitle: 'View all orders here.',
                                    parentMenu: ECOMMERCE_ORDER_MENU_KEY,
                                },
                                props: true,
                                component: () => import('@/views/v2/ecommerce/OrdersByStatus.vue'),
                            },
                        ],
                    },
                ],
            },
            {
                path: 'broadcast',
                component: Wrapper,
                meta: { ...meta, title: 'Broadcast' },
                children: [
                    {
                        path: '/',
                        name: 'insurance-broadcasts',
                        meta: {
                            title: 'Broadcast',
                            subtitle: 'Businesses will have up to 24 hours to respond to a user. Messages sent within the 24-hour window ' +
                                'may contain promotional content. We know people expect businesses to respond quickly, and ' +
                                'businesses that respond to users in a timely manner achieve better outcomes. We highly encourage ' +
                                'businesses to respond to people’s messages as soon as possible.',
                            parentMenu: ECOMMERCE_MARKETING_MENU_KEY,
                        },
                        component: () => import('@/views/v2/Broadcast.vue'),
                    },
                ],
            },
            {
                path: 'referrals',
                component: Wrapper,
                meta: { ...meta, title: 'Referrals' },
                children: [
                    {
                        path: '',
                        component: Referrals,
                        meta: { ...meta, title: 'Referrals' },
                        children: [
                            {
                                path: '/',
                                name: 'insurance-referral',
                                meta: {
                                    title: 'Referrals',
                                    redirect: 'insurance-referral',
                                    parentMenu: ECOMMERCE_MARKETING_MENU_KEY,
                                },
                                component: ReferralList,
                            },
                            {
                                path: 'smart-retail-links',
                                component: Wrapper,
                                meta: { ...meta, title: 'Referrals' },
                                children: [
                                    {
                                        path: '/',
                                        name: 'insurance-smart-retail',
                                        meta: {
                                            title: 'Smart Retail Links',
                                            redirect: 'insurance-smart-retail',
                                            parentMenu: ECOMMERCE_MARKETING_MENU_KEY,
                                        },
                                        component: SmartRetailLinks,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: ':referralLinkUuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'details',
                                name: 'insurance-referral-details',
                                meta: { title: 'Referral Details', parentMenu: ECOMMERCE_MARKETING_MENU_KEY },
                                component: () => import('@/views/v2/ReferralDetails.vue'),
                                props: true,
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
